/*
  Truck Command Center. Controls the website's live location + global ordering
  switch (via the Apps Script endpoint) and launches the delivery apps.
  The PIN gate is a soft lock to keep customers out, not real security.
*/
(function () {
  'use strict';

  function init(root) {
    var endpoint = root.getAttribute('data-endpoint') || '';
    var pin = root.getAttribute('data-pin') || '';

    var gate = root.querySelector('[data-wb-cmd-gate]');
    var panel = root.querySelector('[data-wb-cmd-panel]');
    var pinInput = root.querySelector('[data-wb-cmd-pininput]');
    var unlockBtn = root.querySelector('[data-wb-cmd-unlock]');
    var gateErr = root.querySelector('[data-wb-cmd-gateerr]');

    var locEl = root.querySelector('[data-wb-cmd-loc]');
    var ordStateEl = root.querySelector('[data-wb-cmd-ordstate]');
    var labelEl = root.querySelector('[data-wb-cmd-label]');
    var checkinBtn = root.querySelector('[data-wb-cmd-checkin]');
    var gpsMsg = root.querySelector('[data-wb-cmd-gpsmsg]');
    var ordBtns = root.querySelectorAll('[data-wb-cmd-ord]');
    var ordMsg = root.querySelector('[data-wb-cmd-ordmsg]');
    /* ---- soft PIN gate ---- */
    var STORAGE = 'wbCmdUnlocked';
    function unlock() {
      if (gate) { gate.style.display = 'none'; }
      if (panel) { panel.classList.add('is-open'); }
      refresh();
    }
    if (pin) {
      var already = false;
      try { already = window.sessionStorage.getItem(STORAGE) === pin; } catch (e) {}
      if (already) { unlock(); }
      if (unlockBtn) {
        unlockBtn.addEventListener('click', function () {
          if (pinInput && pinInput.value === pin) {
            try { window.sessionStorage.setItem(STORAGE, pin); } catch (e) {}
            unlock();
          } else if (gateErr) {
            gateErr.textContent = 'Wrong PIN';
          }
        });
      }
      if (pinInput) {
        pinInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { unlockBtn.click(); }
        });
      }
    } else {
      refresh();
    }

    /* ---- helpers ---- */
    function say(el, msg, cls) {
      if (!el) { return; }
      el.textContent = msg;
      el.className = (el.getAttribute('data-base') || el.className.split(' ')[0]) + (cls ? ' ' + cls : '');
    }
    function ping(params, done) {
      if (!endpoint) { done(null); return; }
      var qs = Object.keys(params).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
      }).join('&');
      var url = endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + qs;
      fetch(url, { method: 'GET' })
        .then(function (r) { return r.json(); })
        .then(function (j) { done(j); })
        .catch(function () { done(null); });
    }

    function paintState(state) {
      if (!state) { return; }
      if (locEl) {
        if (state.label || (state.lat && state.ageMinutes !== null)) {
          locEl.textContent = (state.label || 'Pinned') + ' \u00b7 ' + state.ageMinutes + 'm ago';
          locEl.className = 'wb-cmd__nowval is-live';
        } else {
          locEl.textContent = 'On schedule';
          locEl.className = 'wb-cmd__nowval';
        }
      }
      if (ordStateEl) {
        var on = state.ordering !== 'off';
        ordStateEl.textContent = on ? 'ON' : 'PAUSED';
        ordStateEl.className = 'wb-cmd__nowval ' + (on ? 'is-live' : 'is-off');
      }
      for (var i = 0; i < ordBtns.length; i++) {
        var v = ordBtns[i].getAttribute('data-wb-cmd-ord');
        ordBtns[i].classList.remove('is-active-on', 'is-active-off');
        if (state.ordering !== 'off' && v === 'on') { ordBtns[i].classList.add('is-active-on'); }
        if (state.ordering === 'off' && v === 'off') { ordBtns[i].classList.add('is-active-off'); }
      }
    }

    function refresh() {
      if (!endpoint) { return; }
      fetch(endpoint, { method: 'GET' })
        .then(function (r) { return r.json(); })
        .then(paintState)
        .catch(function () {});
    }

    /* ---- check-in ---- */
    if (checkinBtn) {
      checkinBtn.addEventListener('click', function () {
        if (!endpoint) { say(gpsMsg, 'No endpoint set in Theme settings.', 'is-err'); return; }
        if (!navigator.geolocation) { say(gpsMsg, 'This phone has no location.', 'is-err'); return; }
        say(gpsMsg, 'Getting GPS...');
        navigator.geolocation.getCurrentPosition(function (pos) {
          say(gpsMsg, 'Pinning...');
          ping({
            lat: pos.coords.latitude,
            lon: pos.coords.longitude,
            label: labelEl ? labelEl.value.trim() : ''
          }, function (state) {
            if (state) { say(gpsMsg, 'Location updated. Now update the apps below \u2193', 'is-ok'); paintState(state); }
            else { say(gpsMsg, 'Sent. Now update the apps below \u2193', 'is-ok'); }
            if (root.wbResetSteps) { root.wbResetSteps(); }
          });
        }, function () {
          say(gpsMsg, 'Could not get a GPS fix. Try again outside.', 'is-err');
        }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
      });
    }

    /* ---- ordering toggle ---- */
    for (var i = 0; i < ordBtns.length; i++) {
      ordBtns[i].addEventListener('click', function () {
        var v = this.getAttribute('data-wb-cmd-ord');
        if (!endpoint) { say(ordMsg, 'No endpoint set.', 'is-err'); return; }
        say(ordMsg, 'Updating...');
        ping({ ordering: v }, function (state) {
          if (state) { paintState(state); }
          /* Verify the value actually persisted by re-reading the sheet. If it
             did not stick, the deployed Apps Script is the old version and must
             be redeployed as a New version. */
          setTimeout(function () {
            fetch(endpoint, { method: 'GET' })
              .then(function (r) { return r.json(); })
              .then(function (fresh) {
                paintState(fresh);
                if (fresh && fresh.ordering === v) {
                  say(ordMsg, v === 'on'
                    ? '\u2713 Saved. Website ordering is LIVE.'
                    : '\u2713 Saved. Website ordering is PAUSED site-wide.', 'is-ok');
                } else {
                  say(ordMsg, 'Did NOT save. Redeploy your Apps Script as a New version.', 'is-err');
                }
              })
              .catch(function () { say(ordMsg, 'Sent, but could not verify.', 'is-err'); });
          }, 900);
        });
      });
    }

    /* ---- step checklist ---- */
    var stepsWrap = root.querySelector('[data-wb-cmd-steps]');
    var stepDone = root.querySelector('[data-wb-cmd-stepdone]');

    function updateStepsSummary() {
      if (!stepsWrap) { return; }
      var manual = stepsWrap.querySelectorAll('.wb-cmd__step[data-wb-step]');
      var done = stepsWrap.querySelectorAll('.wb-cmd__step[data-wb-step].is-done');
      if (stepDone) { stepDone.hidden = !(manual.length > 0 && done.length === manual.length); }
    }

    function resetSteps() {
      if (!stepsWrap) { return; }
      var steps = stepsWrap.querySelectorAll('.wb-cmd__step[data-wb-step]');
      for (var s = 0; s < steps.length; s++) {
        steps[s].classList.remove('is-done');
        var btn = steps[s].querySelector('[data-wb-step-toggle]');
        if (btn) { btn.innerHTML = '\u25EF'; }
      }
      updateStepsSummary();
    }

    if (stepsWrap) {
      var toggles = stepsWrap.querySelectorAll('[data-wb-step-toggle]');
      for (var t = 0; t < toggles.length; t++) {
        toggles[t].addEventListener('click', function () {
          var li = this.closest('.wb-cmd__step');
          if (!li) { return; }
          var nowDone = li.classList.toggle('is-done');
          this.innerHTML = nowDone ? '\u2713' : '\u25EF';
          updateStepsSummary();
        });
      }
    }
    /* expose so the check-in handler can reset the list for the new stop */
    root.wbResetSteps = resetSteps;
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wb-cmd]');
    for (var i = 0; i < roots.length; i++) { init(roots[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
